/* dz-prodotto.js — Cicli Dal Zilio
 *
 * Logica della scheda prodotto: selezione variante, consigliatore taglia,
 * calcolatore rata, galleria.
 *
 * Non scrive nulla su Shopify: legge i dati già presenti nella pagina.
 * La disponibilità di ogni variante è quella di Shopify, cioè quella del feed
 * (sync.ciclidalzilio.com): il tema si limita a mostrarla correttamente.
 */
(function () {
  "use strict";

  var sezione = document.querySelector("[data-dz-prodotto]");
  if (!sezione) return;

  var leggiJSON = function (sel, fallback) {
    var el = sezione.querySelector(sel);
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn("[DZ] JSON non valido in " + sel, e);
      return fallback;
    }
  };

  var GREZZE = leggiJSON("[data-dz-varianti]", []);
  var TABELLE = leggiJSON("[data-dz-tabelle-taglie]", {});
  var NOME = leggiJSON("[data-dz-prodotto-nome]", "");
  if (!GREZZE.length) return;

  /* Stile per colori esauriti (barrati, come le taglie non disponibili). */
  (function () {
    var st = document.createElement("style");
    st.textContent =
      ".dz-sw.off{opacity:.45;position:relative}" +
      ".dz-sw.off span{text-decoration:line-through}" +
      ".dz-size.off{opacity:.4;text-decoration:line-through;cursor:not-allowed}";
    document.head.appendChild(st);
  })();

  /* Taglia e colore non sempre esistono come opzioni: nel catalogo importato
     stanno dentro il titolo della variante. Qui li ricaviamo, senza toccare i dati. */
  var TAGLIE = ["XXS", "XS", "S", "SM", "M", "MD", "ML", "L", "LG", "XL", "XXL", "XXXL"];

  function ricavaTaglia(titolo) {
    var parole = String(titolo).replace(/[\/(),]/g, " ").split(/\s+/).filter(Boolean);
    for (var i = parole.length - 1; i >= 0; i--) {
      var w = parole[i].toUpperCase();
      if (TAGLIE.indexOf(w) !== -1) return w;
      if (/^(4[4-9]|5[0-9]|6[0-4])$/.test(w)) return w;
    }
    return "";
  }

  function ricavaColore(titolo) {
    var s = String(titolo);
    String(NOME).split(/\s+/).forEach(function (w) {
      if (w.length >= 2) s = s.replace(new RegExp("\\b" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\b", "gi"), " ");
    });
    return s
      .replace(/\bbike\b/gi, " ")
      .replace(/\((?:EU|TW|IT|DE|US|CH)\)/gi, " ")
      .replace(/\b[A-Z]{4}\b\s*\/?/g, " ")
      .replace(/\b(XXS|XS|S|SM|M|MD|ML|L|LG|XL|XXL|XXXL)\b/g, " ")
      .replace(/\b(4[4-9]|5[0-9]|6[0-4])\b/g, " ")
      .replace(/\s{2,}/g, " ")
      .replace(/^[\s\/\-–]+|[\s\/\-–]+$/g, "")
      .trim();
  }

  var VARIANTI = GREZZE.map(function (v) {
    var t = v.taglia_vera || ricavaTaglia(v.titolo);
    /* Il feed Scott mette l'intera variante (colore + taglia) dentro l'opzione
       "Color": in quel caso non è un vero colore, lo ricaviamo dal titolo.
       Altrimenti ogni taglia diventerebbe un "colore" a sé. */
    var cv = v.colore_vero;
    if (cv && !v.taglia_vera && ricavaTaglia(cv)) cv = "";
    var c = cv || ricavaColore(v.titolo);
    if (c === "Default Title" || c === t) c = "";
    return { id: v.id, taglia: t, colore: c, disponibile: v.disponibile, sku: v.sku, ean: v.ean,
             prezzo: v.prezzo, listino: v.listino, prezzo_html: v.prezzo_html, foto: v.foto || "" };
  });

  var $ = function (s) { return sezione.querySelector(s); };
  var euro = function (n) {
    return "€ " + Number(n).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  /* ---------- stato ---------- */
  var colori = [];
  VARIANTI.forEach(function (v) {
    if (v.colore && colori.indexOf(v.colore) === -1) colori.push(v.colore);
  });
  var haTaglie = VARIANTI.some(function (v) { return v.taglia; });

  var iniziale = VARIANTI.filter(function (v) { return v.disponibile; })[0] || VARIANTI[0];
  var stato = { colore: iniziale.colore, taglia: iniziale.taglia };

  /* ---------- selezione variante ---------- */
  function varianteCorrente() {
    return (
      VARIANTI.filter(function (v) {
        return (!stato.colore || v.colore === stato.colore) && (!stato.taglia || v.taglia === stato.taglia);
      })[0] || null
    );
  }

  function taglieDelColore(colore) {
    return VARIANTI.filter(function (v) {
      return !colore || v.colore === colore;
    });
  }

  function coloreDisponibile(colore) {
    return taglieDelColore(colore).some(function (v) { return v.disponibile; });
  }

  function aggiorna() {
    var v = varianteCorrente();
    var aggiungi = $("[data-dz-aggiungi]");
    if (aggiungi && aggiungi.firstChild && !aggiungi.dataset.dzTesto) {
      aggiungi.dataset.dzTesto = aggiungi.firstChild.textContent;
    }

    /* Nessuna variante corrisponde alla scelta: mai lasciare selezionata
       un'altra variante di nascosto, blocca l'acquisto. */
    if (!v) {
      if (aggiungi) {
        aggiungi.disabled = true;
        aggiungi.firstChild.textContent = "Non disponibile ";
      }
      disegnaTaglie();
      return;
    }

    var campo = $("[data-dz-variante]");
    if (campo) campo.value = v.id;

    var prezzo = $("[data-dz-prezzo]");
    if (prezzo) prezzo.textContent = v.prezzo_html;
    var prezzoBtn = $("[data-dz-prezzo-btn]");
    if (prezzoBtn) prezzoBtn.textContent = v.prezzo_html;
    var prezzoBar = $("[data-dz-bar-prezzo]");
    if (prezzoBar) prezzoBar.textContent = v.prezzo_html;

    var listino = $("[data-dz-listino]");
    var sconto = $("[data-dz-sconto]");
    if (listino && sconto) {
      if (v.listino > v.prezzo) {
        listino.textContent = euro(v.listino);
        sconto.textContent = "−" + Math.round((1 - v.prezzo / v.listino) * 100) + "%";
        listino.hidden = false;
        sconto.hidden = false;
      } else {
        listino.hidden = true;
        sconto.hidden = true;
      }
    }

    if (aggiungi) {
      aggiungi.disabled = !v.disponibile;
      aggiungi.firstChild.textContent = v.disponibile ? (aggiungi.dataset.dzTesto || "Aggiungi al carrello · ") : "Non disponibile ";
    }

    if (v.foto) {
      var foto = document.getElementById("dz-foto");
      if (foto && foto.src !== v.foto) foto.src = v.foto;
      /* la stessa foto, piccola, nella barra fissa: cosi' su mobile il colore
         scelto si vede anche quando la galleria e' fuori dallo schermo */
      var barFoto = $("[data-dz-bar-foto]");
      if (barFoto) {
        var piccola = v.foto.replace(/([?&])width=\d+/, "$1width=240");
        if (barFoto.getAttribute("src") !== piccola) barFoto.src = piccola;
      }
    }

    var skuEl = $("[data-dz-sku]");
    if (skuEl) { skuEl.textContent = v.sku || ""; skuEl.parentElement.hidden = !v.sku; }
    var eanEl = $("[data-dz-ean]");
    if (eanEl) { eanEl.textContent = v.ean || ""; eanEl.parentElement.hidden = !v.ean; }

    calcolaRata();
    disegnaTaglie();
  }


  /* ---------- goccia colore ---------- */
  var MAPPA_COLORI = [
    [/\b(white|bianco|bianca|pearl|perla|ivory|avorio|chalk|snow|cloud|arctic)\b/i, "#f1f1ef"],
    [/\b(black|nero|nera|carbon|carbonio|jet|onyx|midnight|raw|stealth|shadow)\b/i, "#1c1c1e"],
    [/\b(grey|gray|grigio|grigia|graphite|grafite|slate|gunmetal|smoke|tungsten|quarry|stone|shark|antracite|anthracite|titanium|titanio|steel|acciaio|iron|concrete)\b/i, "#8b8e94"],
    [/\b(silver|argento|chrome|cromo|cromato|alluminio|aluminium|aluminum|platinum|platino|mercury|metal)\b/i, "#c8cbd1"],
    [/\b(red|rosso|rossa|crimson|scarlet|ruby|cherry|viper|racing|magma|lava|flame)\b/i, "#d1202b"],
    [/\b(coral|corallo|salmon|salmone|peach|pesca)\b/i, "#ff6f61"],
    [/\b(orange|arancio|arancione|fire|mango|tangerine|amber|ambra)\b/i, "#f26a1b"],
    [/\b(yellow|giallo|gialla|lemon|limone|sun|gold|oro|mustard|senape|citrus)\b/i, "#f2c230"],
    [/\b(green|verde|olive|oliva|lime|mint|menta|forest|moss|muschio|khaki|sage|salvia|jungle|emerald|smeraldo)\b/i, "#3a8f5c"],
    [/\b(teal|petrol|petrolio|turquoise|turchese|aqua|cyan|ciano|lagoon|laguna)\b/i, "#1f8f95"],
    [/\b(blue|blu|navy|cobalt|cobalto|azure|azzurro|azzurra|royal|sky|denim|indigo|ocean|oceano|marine|sapphire|zaffiro)\b/i, "#2554c7"],
    [/\b(purple|viola|violet|lilac|lilla|lavender|lavanda|plum|prugna|magenta|fuchsia|fucsia|grape)\b/i, "#7a3fbf"],
    [/\b(pink|rosa|rose|blush|flamingo)\b/i, "#e8679a"],
    [/\b(brown|marrone|bronze|bronzo|copper|rame|chocolate|cioccolato|coffee|caffe|mocha|rust|ruggine|terracotta|cognac)\b/i, "#8a5a3c"],
    [/\b(beige|sand|sabbia|cream|crema|tan|desert|deserto|dune|linen|lino|bone|oat)\b/i, "#d8c8a8"]
  ];
  function coloreDaNome(nome) {
    var trovati = [];
    String(nome).split(/\s*(?:\/|,|\+|&| e | and |-)\s*/i).forEach(function (parte) {
      for (var i = 0; i < MAPPA_COLORI.length; i++) {
        if (MAPPA_COLORI[i][0].test(parte)) { trovati.push(MAPPA_COLORI[i][1]); break; }
      }
    });
    if (!trovati.length) {
      for (var k = 0; k < MAPPA_COLORI.length; k++) {
        if (MAPPA_COLORI[k][0].test(nome)) { trovati.push(MAPPA_COLORI[k][1]); break; }
      }
    }
    return trovati;
  }
  function stileGoccia(nome) {
    var t = coloreDaNome(nome);
    if (!t.length) return "";
    return ' style="--c:' + t[0] + (t[1] ? ";--c2:" + t[1] : "") + '"';
  }
  var fotoColoreCache = {};
  function coloriDallaFoto(box) {
    Array.prototype.forEach.call(box.querySelectorAll(".dz-drop"), function (el) {
      if (el.getAttribute("style")) return;
      var nome = el.getAttribute("data-dz-drop");
      var v = VARIANTI.filter(function (x) { return x.colore === nome && x.foto; })[0];
      if (!v) return;
      var src = v.foto.replace(/([?&])width=\d+/, "$1width=120");
      if (fotoColoreCache[src]) { el.style.setProperty("--c", fotoColoreCache[src]); return; }
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        try {
          var W = 60, H = Math.max(1, Math.round(W * img.naturalHeight / img.naturalWidth));
          var cv = document.createElement("canvas"); cv.width = W; cv.height = H;
          var ctx = cv.getContext("2d", { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, W, H);
          var d = ctx.getImageData(0, 0, W, H).data, r = 0, g = 0, b = 0, n = 0, r2 = 0, g2 = 0, b2 = 0, n2 = 0;
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] < 40) continue;
            var mx = Math.max(d[i], d[i + 1], d[i + 2]), mn = Math.min(d[i], d[i + 1], d[i + 2]);
            if (mx > 235 && mn > 225) continue;              /* sfondo bianco */
            if (mx - mn > 28 && mx > 60) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }   /* pixel colorati */
            else { r2 += d[i]; g2 += d[i + 1]; b2 += d[i + 2]; n2++; }                        /* neri, grigi, argento */
          }
          var col;
          if (n > 25 && n >= n2 * 0.08) col = "rgb(" + Math.round(r / n) + "," + Math.round(g / n) + "," + Math.round(b / n) + ")";
          else if (n2) col = "rgb(" + Math.round(r2 / n2) + "," + Math.round(g2 / n2) + "," + Math.round(b2 / n2) + ")";
          if (col) { fotoColoreCache[src] = col; el.style.setProperty("--c", col); }
        } catch (e) { /* CORS o canvas non disponibile: resta la goccia neutra */ }
      };
      img.src = src;
    });
  }

  /* ---------- colori ---------- */
  function disegnaColori() {
    var box = $("[data-dz-colori]");
    var blocco = $("[data-dz-blocco-colore]");
    if (!box || colori.length < 2) return;
    blocco.hidden = false;

    /* scheda premium: accanto al nome una goccia di vetro del colore.
       Il colore si ricava dal nome (italiano/inglese, anche bicolore
       "Cobalt Blue / Living Coral"); se il nome non dice nulla, viene
       letto dalla foto della variante. Non tocca i dati. */
    var premium = sezione.classList.contains("dz-premium");
    box.innerHTML = colori
      .map(function (c) {
        var attivo = c === stato.colore ? " on" : "";
        var esaurito = coloreDisponibile(c) ? "" : " off";
        var titolo = c + (esaurito ? " (non disponibile)" : "");
        var goccia = premium ? '<i class="dz-drop" data-dz-drop="' + c.replace(/"/g, "&quot;") + '"' + stileGoccia(c) + '></i>' : "";
        return '<button type="button" class="dz-sw' + attivo + esaurito + (premium ? " has-drop" : "") + '" data-colore="' + c.replace(/"/g, "&quot;") + '" title="' + titolo.replace(/"/g, "&quot;") + '">' + goccia + '<span>' + c + "</span></button>";
      })
      .join("");
    if (premium) coloriDallaFoto(box);

    var nome = $("[data-dz-colore-nome]");
    if (nome) nome.textContent = (stato.colore || "") + (stato.colore && !coloreDisponibile(stato.colore) ? " · non disponibile" : "");
  }

  /* ---------- taglie ---------- */
  function disegnaTaglie() {
    var box = $("[data-dz-taglie]");
    var blocco = $("[data-dz-blocco-taglia]");
    if (!box || !haTaglie) return;
    blocco.hidden = false;

    var lista = taglieDelColore(stato.colore).filter(function (v) { return v.taglia; });
    box.innerHTML = lista
      .map(function (v) {
        var cls = "dz-size" + (v.taglia === stato.taglia ? " on" : "") + (v.disponibile ? "" : " off");
        return (
          '<button type="button" class="' + cls + '" data-taglia="' + v.taglia + '"' +
          (v.disponibile ? "" : ' disabled title="Non disponibile"') + ">" + v.taglia + "</button>"
        );
      })
      .join("");

    var n = $("[data-dz-ntaglie]");
    if (n) n.textContent = lista.length;
  }

  /* ---------- consigliatore taglia ---------- */
  function tabellaPer(marca) {
    var chiavi = Object.keys(TABELLE);
    for (var i = 0; i < chiavi.length; i++) {
      if (chiavi[i].toUpperCase() === String(marca).toUpperCase()) return TABELLE[chiavi[i]];
    }
    return null;
  }

  function consiglia() {
    var out = $("[data-dz-adv-out]");
    var input = document.getElementById("dz-altezza");
    if (!out || !input) return;

    var h = parseInt(input.value, 10);
    if (!h || h < 140 || h > 210) {
      out.className = "dz-adv-out warn";
      out.textContent = "Inserisci un'altezza tra 140 e 210 cm.";
      return;
    }

    var marca = (sezione.querySelector(".dz-eye") || {}).textContent || "";
    marca = marca.split("·")[0].trim();
    var tabella = tabellaPer(marca);

    var presenti = taglieDelColore(stato.colore).map(function (v) { return v.taglia; });
    var righe = (tabella || []).filter(function (r) { return presenti.indexOf(r[0]) !== -1; });

    if (!righe.length) {
      out.className = "dz-adv-out warn";
      out.textContent = "Per questo modello non abbiamo una tabella taglie: scrivici e ti aiutiamo noi.";
      return;
    }

    var scelta = righe.filter(function (r) { return h >= r[1] && h < r[2]; })[0];
    var fuori = false;
    if (!scelta) {
      fuori = true;
      scelta = h < righe[0][1] ? righe[0] : righe[righe.length - 1];
    }

    var v = taglieDelColore(stato.colore).filter(function (x) { return x.taglia === scelta[0]; })[0];
    var disponibile = v && v.disponibile;

    out.className = "dz-adv-out";
    out.innerHTML =
      "Per " + h + " cm la taglia consigliata è <span class='dz-pill'>" + scelta[0] + "</span>" +
      (fuori ? " (sei ai limiti della gamma, meglio una prova in negozio)" : " — pensata per " + scelta[1] + "–" + scelta[2] + " cm") +
      (disponibile ? ". <b class='dz-ok'>Disponibile</b>, l'abbiamo selezionata per te." : ". <b>Non disponibile</b> ora: scrivici e la ordiniamo.");

    if (disponibile) {
      stato.taglia = scelta[0];
      aggiorna();
    }
  }

  /* ---------- finanziamento ---------- */
  function calcolaRata() {
    var box = $("[data-dz-fin]");
    var v = varianteCorrente();
    if (!v) return;

    var mesiEl = sezione.querySelector("[data-dz-fin-range]");
    var mesi = mesiEl ? parseInt(mesiEl.value, 10) : 48;
    var tan = box ? parseFloat(box.dataset.tan) / 100 : 0;
    var i = tan / 12;
    var rata = i > 0 ? (v.prezzo * i) / (1 - Math.pow(1 + i, -mesi)) : v.prezzo / mesi;

    var da = $("[data-dz-rata]");
    if (da) da.textContent = euro(Math.round(rata));
    var barRata = $("[data-dz-bar-rata]");
    if (barRata) barRata.textContent = euro(Math.round(rata));
    /* numeri chiave: possono stare in due punti (scheda premium e sezione "Il modello") */
    document.querySelectorAll("[data-dz-fig-rata]").forEach(function (el) { el.textContent = euro(Math.round(rata)); });
    document.querySelectorAll("[data-dz-fig-mesi]").forEach(function (el) { el.textContent = mesi; });
    if (box) {
      var r = $("[data-dz-fin-rata]");
      var m = $("[data-dz-fin-mesi]");
      if (r) r.textContent = euro(Math.round(rata));
      if (m) m.textContent = mesi;
    }
  }

  /* ---------- eventi ---------- */
  sezione.addEventListener("click", function (e) {
    var sw = e.target.closest("[data-colore]");
    if (sw) {
      stato.colore = sw.dataset.colore;
      var delColore = taglieDelColore(stato.colore);
      /* prima taglia disponibile del colore; se il colore è esaurito, la
         prima taglia (così la scheda mostra "Non disponibile" e non resta
         selezionata la variante precedente) */
      var scelta = delColore.filter(function (v) { return v.disponibile; })[0] || delColore[0];
      if (scelta) stato.taglia = scelta.taglia;
      disegnaColori();
      aggiorna();
      return;
    }

    var sz = e.target.closest("[data-taglia]");
    if (sz && !sz.disabled) {
      stato.taglia = sz.dataset.taglia;
      aggiorna();
      return;
    }

    var th = e.target.closest("[data-dz-thumb]");
    if (th) {
      sezione.querySelectorAll("[data-dz-thumb]").forEach(function (t) { t.classList.remove("on"); });
      th.classList.add("on");
      var foto = document.getElementById("dz-foto");
      if (foto && th.dataset.src) foto.src = th.dataset.src;
      return;
    }

    if (e.target.closest("[data-dz-apri-taglie]")) {
      var adv = $("[data-dz-adv]");
      if (adv) {
        adv.hidden = !adv.hidden;
        if (!adv.hidden) document.getElementById("dz-altezza").focus();
      }
      return;
    }

    if (e.target.closest("[data-dz-calcola]")) { consiglia(); return; }

    var q = e.target.closest("[data-dz-q]");
    if (q) {
      var campo = sezione.querySelector('input[name="quantity"]');
      campo.value = Math.max(1, (parseInt(campo.value, 10) || 1) + parseInt(q.dataset.dzQ, 10));
    }
  });

  sezione.addEventListener("input", function (e) {
    if (e.target.matches("[data-dz-fin-range]")) calcolaRata();
  });

  sezione.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.id === "dz-altezza") {
      e.preventDefault();
      consiglia();
    }
  });

  /* ---------- avvio ---------- */
  disegnaColori();
  aggiorna();

  /* ---------- barra fissa: compare quando la galleria esce dalla vista ---------- */
  var barra = sezione.querySelector("[data-dz-pdpbar]");
  var galleria = sezione.querySelector(".dz-gallery");
  if (barra && galleria && "IntersectionObserver" in window) {
    /* La barra si aggancia sotto l'intestazione sticky del sito: l'altezza
       cambia (striscia annunci, mobile), quindi la misuriamo invece di
       fissarla nel CSS. */
    var intest = document.querySelector(".dz header, header");
    var sistemaBarra = function () {
      if (!intest) return;
      var giu = intest.getBoundingClientRect().bottom;
      barra.style.top = Math.max(0, Math.round(giu)) + "px";
    };
    var io = new IntersectionObserver(function (voci) {
      var e = voci[0];
      /* compare solo quando la galleria è già passata SOPRA (scroll verso il
         basso), non quando sta ancora sotto la piega (es. apertura premium
         su mobile, dove all'avvio la galleria non è ancora in vista) */
      var sopra = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (sopra) sistemaBarra();
      barra.classList.toggle("show", sopra);
    }, { rootMargin: "-140px 0px 0px 0px", threshold: 0 });
    io.observe(galleria);
    var attesaBarra = false;
    window.addEventListener("scroll", function () {
      if (attesaBarra || !barra.classList.contains("show")) return;
      attesaBarra = true;
      requestAnimationFrame(function () { attesaBarra = false; sistemaBarra(); });
    }, { passive: true });
    window.addEventListener("resize", sistemaBarra);

    var barraAdd = barra.querySelector("[data-dz-bar-add]");
    if (barraAdd) {
      barraAdd.addEventListener("click", function () {
        var principale = $("[data-dz-aggiungi]");
        if (principale && !principale.disabled) principale.click();
        else window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  }

  /* ---------- numeri chiave sotto la scheda ---------- */
  (function () {
    var setT = {};
    VARIANTI.forEach(function (v) { if (v.taglia) setT[v.taglia] = 1; });
    var quante = Object.keys(setT).length;
    if (quante) document.querySelectorAll("[data-dz-fig-taglie]").forEach(function (el) { el.textContent = quante; });
    if (colori.length > 0) {
      document.querySelectorAll("[data-dz-fig-colori]").forEach(function (el) { el.textContent = colori.length; });
      document.querySelectorAll("[data-dz-fig-colori-label]").forEach(function (el) {
        el.textContent = colori.length === 1 ? "Colorazione" : "Colorazioni";
      });
    }
  })();

  /* ---------- zoom foto: si apre al massimo restando tutta nello schermo ---------- */
  var zb = document.querySelector("[data-dz-zoombox]");
  var mainImg = document.getElementById("dz-foto");
  if (zb && mainImg) {
    var zi = zb.querySelector("img");
    var apri = function () { zi.src = mainImg.src; zb.classList.add("open"); };
    var chiudi = function () { zb.classList.remove("open"); };
    mainImg.addEventListener("click", apri);
    zb.addEventListener("click", chiudi);
    window.addEventListener("keydown", function (e) { if (e.key === "Escape") chiudi(); });
  }
})();
